import React from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { PLATFORM_ACCENTS, formatINR, formatNumber } from '@/lib/format';
import { Sparkle, Check } from 'lucide-react';

export function PlanCard({ plan, platform, selected = false, onSelect, unitLabel }) {
    const accent = PLATFORM_ACCENTS[platform] || PLATFORM_ACCENTS.olaparty;
    return (
        <Card
            data-testid={`plan-card-${platform}-${plan.price_inr}`}
            className={`relative bg-card border-border rounded-2xl p-4 flex flex-col cursor-pointer transition-shadow ${selected ? 'ring-2 ring-[#2B7BBB] shadow-soft' : 'hover:shadow-soft'}`}
            onClick={() => onSelect && onSelect(plan)}
        >
            {plan.popular && (
                <Badge
                    className="absolute -top-2 right-3 border"
                    style={{ background: accent.bg, color: accent.color, borderColor: accent.border }}
                >
                    <Sparkle className="h-3 w-3 mr-1" /> Popular
                </Badge>
            )}
            <div className="flex items-baseline gap-1.5">
                <div className="text-2xl font-display font-semibold tabular-nums text-foreground">{formatNumber(plan.amount)}</div>
                <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{unitLabel}</div>
            </div>
            {platform === 'olaparty' && (
                <div className="text-xs text-amber-600 font-medium mt-0.5" data-testid={`plan-diamond-preview-${plan.price_inr}`}>
                    ≈ {(plan.amount / 200).toLocaleString(undefined, { maximumFractionDigits: 2 })} 💎 <span className="text-muted-foreground font-normal">(preview)</span>
                </div>
            )}
            <div className="text-xs text-muted-foreground mt-0.5">{plan.label || 'Recharge plan'}</div>
            <div className="mt-3 flex items-end justify-between">
                <div>
                    <div className="text-[10px] text-muted-foreground uppercase tracking-wider">Price</div>
                    <div className="text-lg font-display font-semibold tabular-nums text-foreground">{formatINR(plan.price_inr)}</div>
                </div>
                <Button
                    type="button"
                    size="sm"
                    variant={selected ? 'default' : 'outline'}
                    onClick={(e) => { e.stopPropagation(); onSelect && onSelect(plan); }}
                    data-testid={`plan-select-button-${platform}-${plan.price_inr}`}
                    className={selected ? 'bg-[#0E2A47] hover:bg-[#0B223A]' : ''}
                >
                    {selected ? <><Check className="h-3.5 w-3.5 mr-1" /> Selected</> : 'Select'}
                </Button>
            </div>
        </Card>
    );
}
